/* exported bocAmchart */

/**
 * Container object for Bank of Canada functions for setting up AmCharts
 */
var bocAmchart = {};

/**
 * Version file, listing the features implemented, latest at the end of the array (under features),
 * make sure to separate the tasks to avoid merge conflicts
 * The entries could be deleted after they are code released on prod (not via uploads)
 * @type {{svn: string, features: string[]}}
 */
bocAmchart.version = {
    "svn": "$Revision: 29283 $",
    "features": {}
};

bocAmchart.version.features['DEV-5585'] = [
    "Waterfall chart type",
    "Dashed lines with dates",
    "Transpose data",
    "Category labels wrapping functions",
    "Proper formatting for waterfall balloons",
    "Version info"
];

bocAmchart.version.features['DEV-5602'] = [
    "Bullet type"
];

bocAmchart.version.features['DEV-5618'] = [
    "Set minimum width for charts on print"
];

bocAmchart.version.features['DEV-5472'] = [
    "Fix pre-zoom reset on print"
];

bocAmchart.version.features['DEV-5526'] = [
    "Added category type and non-time post processor",
    "Added the postProcessor for XY chart with new non-time data",
    "Fixed the support for values in json as strings in waterfall postprocessor",
    "Added support for selecting the label index for pie chart"
];

bocAmchart.version.features['DEV-5709'] = [
    "Added ability to transpose the data, even if it's time series, to use dates as series",
    "Added attribute to hide the legend",
    "Fixed the code order so that color can be customized for XY charts"
];

bocAmchart.version.features['DEV-5842'] = [
    "Changed the code to preserve the order of the series (becoming categories) when using transposing of the time data"
];

bocAmchart.version.features['DEV-5955'] = [
    "Added the code to handle the non-time series in pie post processor",
    "Fixed processing of the category data, so that it does not fail if category does not have all series"
];

bocAmchart.version.features['DEV-5954'] = [
    "Add the button to switch the stacking of the graphs on/off - refactored to allow bocAmchart.setGraphType()"
];

bocAmchart.version.features['DEV-5969'] = [
    "Refactored the code to save the zoom even if it's not lookup.",
    "Added restoring zoom based on what category is used",
    "Fixed an issue with time series triggering both dates and index functions"
];

bocAmchart.version.features['DEV-6227'] = [
    "Added correct fallback for decoding of the data from webmart",
    "Added the chart object as a parameter for decoder to remove export menu, if decoding is needed"
];

bocAmchart.version.features['DEV-6254'] = [
    "Fixed the bug, when empty date end was used in defining end date for zoom"
];

bocAmchart.version.features['DEV-6267'] = [
    "Added axis data-(left|right)AxisMinimum data-(left|right)AxisMaximum parameters",
    "Added data-rotate parameter",
    "Added data-categoryAxisLabelRotation attribute",
    "Added data-rotateLabelsMaxWidth for responsive rotation of category labels",
    "Disabled category balloon for text category chart by default",
    "Added data-disableCursor parameter to remove cursor completely",
    "Added data-(left|right)AxisUnitPosition parameter to set unit position for axis",
    "Disabled the range data download for non-time category charts, e.g. text, xy",
    "Added data-series0balloonText parameter with {{value}} notation",
    "Added the 16h shift to Guides to make sure they match the data appearance (center at noon the day of)"
];

bocAmchart.version.features['DEV-6236'] = [
    "Refactored the code to allow setting open/close/value fields series for all graphs.",
    "Made possible to use data parameters on candlestick graphs"
];

bocAmchart.version.features['DEV-6650'] = [
    "Added highField and lowField for candlestick text category charts"
];

bocAmchart.version.features['DEV-6825'] = [
    "Reviewed the code to enable dark mode for EWS."
];
